'use strict';
const React = require('react');
const BaseComponent = require('../../../../../../shared/base');

class PurchaseTableContents extends BaseComponent {
    constructor(props) {
        super(props);
    }
}


module.exports = PurchaseTableContents;